import { ObservableArray, View, ViewModel } from "binder"
import { FormBuilderComponentView } from "src/formBuilder/structure/element";
import { ITemplateSelector } from "src/uicomponents/components/templateSelector";
import { getAsBoolean } from "src/uicomponents/components/utilities";
import { ColumnViewModel } from "uicomponents";
import { ClientFilterTableElement } from "./clientFilterTable-viewModel"

export class ClientFilterTableView extends FormBuilderComponentView<ClientFilterTableElement>{
    GetViewUniqueId(): string {
        return "V-14B25769-12C4-4990-908C-9224060D4BB4"
    }
    loadHtml(): string {
        let element = require('./clientFilterTable.html').default;
        let style = require('./clientFilterTable.less');
        return element;
    }
    constructor() {
       super();
    }

    public set ItemsSource(v: ObservableArray<ViewModel>) { this._ItemsSource = v; } public get ItemsSource(): ObservableArray<ViewModel> { return this._ItemsSource;} private _ItemsSource: ObservableArray<ViewModel>;
    public set TemplateSelector(v: ITemplateSelector) { this._TemplateSelector = v; } public get TemplateSelector(): ITemplateSelector { return this._TemplateSelector;} private _TemplateSelector: ITemplateSelector;
    public set ItemTemplateSelector(v: string) { this._ItemTemplateSelector = v; } public get ItemTemplateSelector(): string { return this._ItemTemplateSelector;} private _ItemTemplateSelector: string;
    public set ShowingColumns(v: ObservableArray<ColumnViewModel>) { this._ShowingColumns = v; } public get ShowingColumns(): ObservableArray<ColumnViewModel> { return this._ShowingColumns;} private _ShowingColumns: ObservableArray<ColumnViewModel>;
    public set StickyHeaders(v: boolean) { this._StickyHeaders = getAsBoolean(v); } public get StickyHeaders(): boolean { return this._StickyHeaders;} private _StickyHeaders: boolean;
        
}
